import { colors } from "./colors";

export const formFieldStyles = {
  // Container-Styling
  container: {
    mb: 1,
  },

  // Label-Styling
  label: {
    mb: 1,
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "textSecondary",
  },

  // Feldhöhe/-Innenabstand stehen hier bewusst nicht mehr: die kommen ausschließlich aus
  // `formField` (styles/theme.ts). Eine zweite Quelle dafür hat das Ruhe-Label leerer Felder
  // aus der Mitte laufen lassen.

  // Text Editor Styling (basierend auf InputField)
  textEditor: {
    border: `1px solid ${colors.border.divider}`,
    borderRadius: 1.5,
    backgroundColor: colors.background.paper,
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: colors.border.focus,
      backgroundColor: colors.state.hoverPrimary,
      transform: "translateY(-1px)",
      boxShadow: `0 2px 8px ${colors.shadow.medium}`,
    },
    "&:focus-within": {
      borderColor: colors.brand.primary,
      backgroundColor: colors.background.paper,
      boxShadow: `0 0 0 2px ${colors.brand.primary}20`,
    },
  },

  // Text Editor Readonly Styling (ohne Umrandung, wie InputField)
  textEditorReadonly: {
    border: "none",
    borderRadius: 1.5,
    backgroundColor: "transparent",
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: colors.state.hoverPrimary,
      transform: "translateY(-1px)",
      boxShadow: `0 2px 8px ${colors.shadow.medium}`,
    },
  },

  // Editor Content Area für Readonly (dynamische Höhe)
  editorContentReadonly: {
    p: 2,
    minHeight: "auto",
    maxHeight: "none",
    height: "auto",
    overflow: "visible",
  },

  // Toolbar Styling
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    p: 1,
    borderBottom: `1px solid ${colors.border.divider}`,
    backgroundColor: colors.background.paper,
    flexWrap: "wrap",
  },

  // Editor Content Area
  editorContent: {
    p: 2,
    minHeight: "200px",
    maxHeight: "400px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: colors.background.tableHeaderAlt,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: colors.border.medium,
      borderRadius: "4px",
      "&:hover": {
        background: colors.text.disabled,
      },
    },
  },

  // Content Editable Styling
  contentEditable: {
    outline: "none",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    minHeight: "150px",
    cursor: "text",
    userSelect: "auto",
  },

  // Readonly Content Editable Styling
  contentEditableReadonly: {
    outline: "none",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    minHeight: "auto",
    height: "auto",
    cursor: "default",
    userSelect: "none",
  },
};
